module.exports = __webpack_public_path__ + "static/media/02.be3e5861.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/02.jpg
// module id = 263
// module chunks = 0